"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _react = _interopRequireWildcard(require("react"));
var _BuyProduct = _interopRequireDefault(require("../Business/BuyProduct1"));
var _Svg = _interopRequireDefault(require("./Svg"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};

// import FlexTitle from '../Title';
// import './index.less';

// import { IconFont, MenuSubIcon } from '@tencent/ixd-icons-react';
// eslint-disable-next-line @typescript-eslint/no-require-imports
var _a = require('@tencent/ixd-icons-react/dist'),
  IconFont = _a.IconFont,
  MenuSubIcon = _a.MenuSubIcon;
function index(props) {
  var _a = (0, _react.useState)(['all']),
    typeArr = _a[0],
    setTypeArr = _a[1];
  var _b = (0, _react.useState)(false),
    isShow = _b[0],
    setIsShow = _b[1];
  var mobileTypeArrRef = (0, _react.useRef)(['all']);
  var typeFree = props.typeFreeTier.map(function (item) {
    return __assign(__assign({}, item), {
      checked: true
    });
  });
  var _c = (0, _react.useState)(typeFree),
    checkboxItems = _c[0],
    setCheckboxItems = _c[1];
  var handleChange = function handleChange(index) {
    // console.log('index', index);
    var items = __spreadArrays(checkboxItems);
    items[index].checked = !items[index].checked;
    // 如果点击全选
    if (index === 0) {
      if (items[index].checked) {
        items.forEach(function (item) {
          return item.checked = true;
        });
      } else {
        items.forEach(function (item) {
          return item.checked = false;
        });
      }
    }
    // 如果点击具体类型，全选按钮不勾选
    if (index !== 0 && items.some(function (item) {
      return item.checked === false;
    })) {
      items[0].checked = false;
    }
    // 如果所有具体类型都选择，全部类型也同时勾选
    if (!items.filter(function (item) {
      return item.type !== 'all';
    }).some(function (item) {
      return item.checked === false;
    })) {
      items[0].checked = true;
    }
    // console.log(items, 'items');
    setCheckboxItems(items);
    var arrFilter = items.filter(function (item) {
      return item.checked;
    }).map(function (item) {
      return item.type;
    });
    // console.log(arrFilter)
    setTypeArr(arrFilter);
  };
  var handleMobileChange = function handleMobileChange(index) {
    var items = __spreadArrays(checkboxItems);
    items[index].checked = !items[index].checked;
    // 如果点击全选
    if (index === 0) {
      if (items[index].checked) {
        items.forEach(function (item) {
          return item.checked = true;
        });
      } else {
        items.forEach(function (item) {
          return item.checked = false;
        });
      }
    }
    // 如果点击具体类型，全选按钮不勾选
    if (index !== 0 && items.some(function (item) {
      return item.checked === false;
    })) {
      items[0].checked = false;
    }
    // 如果所有具体类型都选择，全部类型也同时勾选
    if (!items.filter(function (item) {
      return item.type !== 'all';
    }).some(function (item) {
      return item.checked === false;
    })) {
      items[0].checked = true;
    }
    // console.log(items, 'items');
    setCheckboxItems(items);
    var arrFilter = items.filter(function (item) {
      return item.checked;
    }).map(function (item) {
      return item.type;
    });
    // console.log(arrFilter)
    // setTypeArr(arrFilter)
    mobileTypeArrRef.current = arrFilter;
  };
  var handleMobileComfirm = function handleMobileComfirm() {
    // console.log(mobileTypeArrRef.current, 'mobileTypeArrRef.current');
    setTypeArr(mobileTypeArrRef.current);
    setIsShow(false);
  };
  var handleCheck = function handleCheck() {
    setIsShow(true);
  };
  var handleBack = function handleBack() {
    setIsShow(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "free-tier-title"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "free-tier-title-text"
  }, props.flexTitle), /*#__PURE__*/_react["default"].createElement(MenuSubIcon, {
    onClick: handleCheck,
    className: "free-tier-title-svg"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "free-tier-type"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "free-tier-type-container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "free-tier-type-title"
  }, "\u514D\u8D39\u8BD5\u7528\u7C7B\u578B:"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "free-tier-type-contentwrap"
  }, checkboxItems.map(function (item, index) {
    var name = item.name,
      type = item.type,
      checked = item.checked;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "free-tier-type-content",
      key: index,
      onClick: function onClick() {
        return handleChange(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      value: type,
      checked: checkboxItems[index].checked
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "text"
    }, name), checked ? /*#__PURE__*/_react["default"].createElement(_Svg["default"], null) : null);
  })))), isShow && (/*#__PURE__*/_react["default"].createElement("div", {
    className: "free-tier-type-mobile"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "back"
  }, /*#__PURE__*/_react["default"].createElement(IconFont, {
    name: "left",
    onClick: handleBack
  }), /*#__PURE__*/_react["default"].createElement("span", null, "Product & Feature Updates")), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "contentwrap-mobile"
  }, checkboxItems.map(function (item, index) {
    var name = item.name,
      checked = item.checked;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "content-mobile",
      key: index,
      onClick: function onClick() {
        return handleMobileChange(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text"
    }, name), checked ? /*#__PURE__*/_react["default"].createElement(_Svg["default"], null) : null);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "confirmwrap",
    onClick: handleMobileComfirm
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "confirm"
  }, 'confirm')))), /*#__PURE__*/_react["default"].createElement(_BuyProduct["default"], {
    typeArr: typeArr,
    configuration: props.configuration
  }));
}